<template>
  <svg
    style="overflow: visible"
    @mouseenter="mouseenter"
    @mouseleave="mouseleave"
    @mousedown="mousedown"
  >
    <line
      class="end-marker"
      :x1="time"
      :x2="time"
      :y1="5 - height"
      :y2="5 + height"
      :style="{
        stroke: 'black',
        strokeWidth: '0.3',
        cursor: isHighlighted ? 'ew-resize' : 'default'
      }"
    ></line>
  </svg>
</template>

<script setup lang="ts">
import { ref, watch, onUnmounted, onMounted } from "vue";
import { getPercentageFn, changedEndMarkerSubject$ } from "./rxMarble";

const props = defineProps<{
  timelineID: number;
  time: number;
  isInteractive: boolean;
}>();

const height = ref(1.8);

const time = ref<number>(props.time);

watch(
  () => props.time,
  (t) => {
    time.value = t;
  }
);

const isHighlighted = ref<boolean>(false);
const isDraggable = ref<boolean>(false);

const mouseenter = () => {
  if (!props.isInteractive) return;
  isHighlighted.value = true;
  height.value = 3.2;
};

const mouseleave = () => {
  if (!props.isInteractive) return;
  isHighlighted.value = false;
  height.value = 1.8;
};

let parentElement: HTMLElement;
const mousedown = (e: MouseEvent) => {
  if (!props.isInteractive) return;
  isDraggable.value = true;
  parentElement = (e.currentTarget as HTMLElement).parentElement!;
};

function moveMarble(e: MouseEvent) {
  if (!props.isInteractive) return;
  if (isDraggable.value) {
    time.value = getPercentageFn(parentElement)(e.pageX);
    changedEndMarkerSubject$.next({
      timelineID: props.timelineID,
      time: time.value
    });
  }
}
function mouseUp(e: MouseEvent) {
  if (!props.isInteractive) return;
  isDraggable.value = false;
}

onMounted(() => {
  document.addEventListener("mousemove", moveMarble);
  document.addEventListener("mouseup", mouseUp);
});

onUnmounted(() => {
  document.removeEventListener("mousemove", moveMarble);
  document.removeEventListener("mouseup", mouseUp);
});
</script>
